/**
 * Parse unified diff text into DiffLine[] for the design-system Diff component.
 */

import type { DiffLine, DiffLineType } from '../components/design-system/Diff'

export function parseUnifiedDiff(unified: string): DiffLine[] {
  const lines: DiffLine[] = []
  if (!unified) return lines
  let oldNo = 0
  let newNo = 0
  for (const raw of unified.split('\n')) {
    if (raw.startsWith('+++') || raw.startsWith('---') || raw.startsWith('diff ') || raw.startsWith('index ')) {
      continue
    }
    const hunk = /^@@\s+-(\d+)(?:,\d+)?\s+\+(\d+)/.exec(raw)
    if (hunk) {
      oldNo = Number(hunk[1]) - 1
      newNo = Number(hunk[2]) - 1
      lines.push({ type: 'unchanged', content: raw })
      continue
    }
    let type: DiffLineType = 'unchanged'
    let content = raw
    let lineNumber: number | undefined
    if (raw.startsWith('+')) {
      type = 'added'
      content = raw.slice(1)
      newNo += 1
      lineNumber = newNo
    } else if (raw.startsWith('-')) {
      type = 'removed'
      content = raw.slice(1)
      oldNo += 1
      lineNumber = oldNo
    } else if (raw.startsWith(' ') || raw === '') {
      type = 'unchanged'
      content = raw.startsWith(' ') ? raw.slice(1) : raw
      oldNo += 1
      newNo += 1
      lineNumber = newNo
    } else {
      lines.push({ type: 'unchanged', content: raw })
      continue
    }
    lines.push({ type, content, lineNumber })
  }
  return lines
}
